import { useState, type ReactElement } from 'react';
import { useEditor } from '../store';
import { Sheet } from './Sheet';

/**
 * **Alte, nie gesicherte Änderungen** (7.220; Sascha, 4. Oktober: „werden
 * bereiche nicht gespeichert? Weil wenn ich es nun auf dem desktop öffne sind
 * sie weg“).
 *
 * Was dieses Gerät länger als zwölf Stunden nicht an den Server losgeworden
 * ist, wurde bis heute beim nächsten Verbinden verworfen. Jetzt wird gefragt.
 * Nachtragen ist der Normalfall; verwerfen, wer weiss, dass am Schnitt seither
 * anders weitergearbeitet wurde. „Später“ lässt beides liegen -- dann geht
 * auch nichts Neues hinaus, bis entschieden ist.
 */
export function AlteAenderungenSheet(): ReactElement | null {
  const alte = useEditor((s) => s.alteOffen);
  const nachtragen = useEditor((s) => s.alteNachtragen);
  const verwerfen = useEditor((s) => s.alteVerwerfen);
  const [spaeter, setSpaeter] = useState<number | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  if (!alte || spaeter === alte.seit) return null;
  const wann = new Date(alte.seit).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' });
  const wie = alte.schritte === 1 ? 'Eine Änderung' : `${alte.schritte} Änderungen`;
  return (
    <Sheet title="Nicht gesichert" onClose={() => setSpaeter(alte.seit)} closeLabel="Später">
      <p className="hint" style={{ marginTop: 0 }} data-alte-aenderungen={alte.schritte}>
        {wie} von {wann} {alte.schritte === 1 ? 'ist' : 'sind'} auf diesem Gerät nie beim Server angekommen. Seither
        kann am Schnitt weitergearbeitet worden sein.
      </p>
      <div className="list">
        <button className="row" style={{ textAlign: 'left' }} disabled={laeuft} onClick={nachtragen} data-alte-nachtragen>
          Nachtragen
        </button>
        <button
          className="row danger"
          style={{ textAlign: 'left' }}
          disabled={laeuft}
          data-alte-verwerfen
          onClick={async () => {
            setLaeuft(true);
            try {
              await verwerfen();
            } finally {
              setLaeuft(false);
            }
          }}
        >
          Verwerfen
        </button>
      </div>
    </Sheet>
  );
}
